// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as VehicleQuotations from "../entity/VehicleQuotations.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as VehicleQuotationApiModel from "../api-model/VehicleQuotationApiModel.bs.js";

function fareInfoToEntity(data) {
  if (data === undefined) {
    return ;
  }
  var value = data.subscription_discount;
  return {
          fare: Currency.toCurrency(data.fare),
          min_paytm_amount: Currency.toCurrency(data.min_paytm_amount),
          min_paytm_amount_with_credits: Currency.toCurrency(data.min_paytm_amount_with_credits),
          applied_coupon: data.applied_coupon,
          subscription_discount: value !== undefined ? Caml_option.some(Currency.toCurrency(value)) : undefined,
          total_discount: Currency.toCurrency(data.total_discount),
          description: data.description
        };
}

function fareBreakupToEntity(data) {
  var a = $$Array.concat(data);
  return $$Array.map((function (e) {
                return VehicleQuotations.toVarinat(e.field_type, {
                            field_type: e.field_type,
                            title: e.title,
                            value: Currency.toCurrency(e.value),
                            subtext: e.subtext,
                            payable_type: e.payable_type
                          });
              }), a);
}

function billDetailsToEntity(data) {
  if (data === undefined) {
    return ;
  }
  var value = data.previous_dues;
  var value$1 = data.porter_gold_fee;
  var value$2 = data.porter_credits_applied;
  return {
          fare_breakup: fareBreakupToEntity(data.fare_breakup),
          net_fare: Currency.toCurrency(data.net_fare),
          previous_dues: value !== undefined ? Caml_option.some(Currency.toCurrency(value)) : undefined,
          porter_gold_fee: value$1 !== undefined ? Caml_option.some(Currency.toCurrency(value$1)) : undefined,
          porter_credits_applied: value$2 !== undefined ? Caml_option.some(Currency.toCurrency(value$2)) : undefined,
          amount_payable: Currency.toCurrency(data.amount_payable)
        };
}

function subscriptionInfoTotState(data) {
  return {
          status: data.status,
          field_type: data.field_type
        };
}

function serviceToState(data) {
  return $$Array.map((function (e) {
                return {
                        is_enabled: e.is_enabled,
                        field_type: e.field_type
                      };
              }), data);
}

function vasToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        field_type: e.field_type,
                        off_messages: e.off_messages,
                        services: serviceToState(e.services)
                      };
              }), data);
}

function vehicleWiseQuotationToEnity(data) {
  return $$Array.map((function (e) {
                return {
                        vehicle_id: e.vehicle_id,
                        quotation_uuid: e.quotation_uuid,
                        fare_info: fareInfoToEntity(e.fare_info),
                        bill_details: billDetailsToEntity(e.bill_details),
                        subscription_info: subscriptionInfoTotState(e.subscription_info),
                        book_cta_info_text: e.book_cta_info_text,
                        value_added_services: vasToEntity(e.value_added_services)
                      };
              }), data);
}

function paytmWalletToState(data) {
  return {
          login_status: data.login_status,
          balance: data.balance,
          balance_api_status: data.balance_api_status
        };
}

function porterWalletToEntity(data) {
  return {
          amount: data.amount,
          payable: data.payable
        };
}

function walletInfoToState(data) {
  return {
          paytm_wallet: paytmWalletToState(data.paytm_wallet),
          porter_wallet: porterWalletToEntity(data.porter_wallet)
        };
}

function nearbyDriversLocsToEntity(data) {
  return $$Array.map((function (latLng) {
                return {
                        lat: latLng.lat,
                        long: latLng.long
                      };
              }), data);
}

function nearbyVehicleDriversToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        show_vehicle: e.show_vehicle,
                        vehicle_id: e.vehicle_id,
                        eta_mins: e.eta_mins,
                        booking_enabled: e.booking_enabled,
                        booking_disabled_msg: e.booking_disabled_msg,
                        book_till_x_mins: e.book_till_x_mins,
                        show_vehicle_availability_text: e.show_vehicle_availability_text,
                        dil_uuid: e.dil_uuid,
                        driver_locs: nearbyDriversLocsToEntity(e.driver_locs)
                      };
              }), data);
}

function porterGoldDetailsToEntity(data) {
  return {
          is_cancellable: data.is_cancellable,
          benefits: data.benefits
        };
}

function apiModelToEntity(data) {
  return {
          route_polyline: data.route_polyline,
          vehicle_wise_quotations: vehicleWiseQuotationToEnity(data.vehicle_wise_quotations),
          wallet_info: walletInfoToState(data.wallet_info),
          nearby_vehicle_drivers: nearbyVehicleDriversToEntity(data.nearby_vehicle_drivers),
          select_vehicle_id: data.select_vehicle_id,
          porter_gold_details: porterGoldDetailsToEntity(data.porter_gold_details)
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(VehicleQuotationApiModel.t_decode(json), "VehicleQuotationsEntityMapper.res"));
}

export {
  fareInfoToEntity ,
  fareBreakupToEntity ,
  billDetailsToEntity ,
  subscriptionInfoTotState ,
  serviceToState ,
  vasToEntity ,
  vehicleWiseQuotationToEnity ,
  paytmWalletToState ,
  porterWalletToEntity ,
  walletInfoToState ,
  nearbyDriversLocsToEntity ,
  nearbyVehicleDriversToEntity ,
  porterGoldDetailsToEntity ,
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
